export default function siteNotice() {
  const notice = document.querySelector('.siteNotice');

  // Make sure we have a notice
  if (!notice) return;

  const closeBtn = document.querySelector('.siteNotice-closeBtnWrap');
  const noticeId = closeBtn.dataset.closeNotice;
  const header = document.querySelector('.site-header.site-header-sticky');

  closeBtn.addEventListener('click', () => {
    // notice.parentNode.removeChild(notice);
    notice.classList.remove('is-visible');
    document.body.style.paddingTop = '0';
    header.style.top = `-${header.getBoundingClientRect().height}px`;
    localStorage.setItem('notice-closed', noticeId);
  });
}
